/** Shared portability limits (client-side validation). */
export const COLLECTION_EXPORT_FORMAT = "hot-wheels-collection" as const;
export const COLLECTION_EXPORT_VERSION_V1 = 1 as const;
export const COLLECTION_EXPORT_VERSION = 2 as const;
export const COLLECTION_IMPORT_SUPPORTED_VERSIONS = [
  COLLECTION_EXPORT_VERSION_V1,
  COLLECTION_EXPORT_VERSION,
] as const;

/** Matches backend COLLECTION_QUANTITY_MAX / import quantity upper bound. */
export const COLLECTION_QUANTITY_MAX = 10_000;

/** Matches backend COLLECTION_IMPORT_ITEMS_MAX. */
export const COLLECTION_IMPORT_ITEMS_MAX = 10_000;

/** Max JSON file size accepted by the import UI (2 MiB). */
export const COLLECTION_IMPORT_FILE_MAX_BYTES = 2 * 1024 * 1024;

export const COLLECTION_SNAPSHOT_SCHEMA_VERSION = 1 as const;
